module.exports = require('./CheckboxTemplate.jsx');


/** WEBPACK FOOTER **
 ** ./~/subschema/src/templates/CheckboxesTemplate.jsx
 **/